<script>
  import { blocklist, text, richtext, image, url } from "../toolbox.js";
  import { link, links } from "svelte-routing";

  export let block;
</script>

<section id="recent-blog-posts" class="recent-blog-posts">

  <div class="container" data-aos="fade-up">

    <header class="section-header">
      <h2>{text(block, 'subheadline')}</h2>
      <p>{text(block, 'headline')}</p>
    </header>

    <div class="row">

      {#each blocklist(block, 'posts') as item}
      <div class="col-lg-4">
        <div class="post-box">
          <div class="post-img"><img src="{image(item, 'picture', [500, 500])}" class="img-fluid" alt=""></div>
          <span class="post-date">{text(item, 'infoline')}</span>
          <h3 class="post-title">{text(item, 'headline')}</h3>
          <a href="{url(item, 'link')}" class="readmore stretched-link mt-auto"><span>{text(item, 'link')}</span><i class="bi bi-arrow-right"></i></a>
        </div>
      </div>
      {/each}

    </div>

  </div>

</section>
